import { inject } from 'aurelia-framework';
import { Router } from 'aurelia-router'
import { AuthService } from '../../services/authService';
import { UserMessageService } from '../../services/userMessageService';
import {VideoEmailBase} from '../base/videoEmail';
import { VideoEmailAdminAPI } from '../../services/admin/videoEmailAdminAPI';
import { AccountAdminAPI } from '../../services/admin/accountAdminAPI';
import { EnvironmentService } from '../../services/environmentService';

@inject(AuthService, UserMessageService, Router, VideoEmailAdminAPI, AccountAdminAPI, EnvironmentService)
export class VideoEmail extends VideoEmailBase {
    constructor(authService, userMessageService, router, api, accountApi, envService) {
        super(authService, userMessageService, router, "api/admin", api, accountApi, envService, true);
        this.fileBase = null;
        this.awsCheck = false;
        this.dashboardlength = 'col-sm-12';
        this.isdashboard = false;
        this.email = null;
    }
    activate(params, route) {

        super.activate(params, route);
        //if(!params.id && params.account_owner_id) {
        //    this.account_owner_user_id = params.account_owner_id;
        //}

        // if(this.id) {
        //     this.api.getFileList(
        //         this.id, 
        //         this.authService.getUser().token,
        //         this.getFileListSuccess.bind(this),
        //         this.saveLoadError.bind(this));
        // }

        // this.account_owner_id = account_owner_id;
        // this.whitelabel_id = whitelabel_id;
        // this.search = search;
        // this.dataList = null;
        // this.count = null;
        // this.limit = 10;
        // this.page = 1;
        // this.sortBy = "CREATE_DATE";
        // this.sortDir = "DESC";
        // this.selectedlimitPages = 10;


        // this.include_removed = false;
        this.load();
        
    }

    reset() {
       

        // this.accountApi.getUserData(
        //     this.account_owner_user_id,  
        //     this.authService.getUser().token, 
        //     (userData) => {
        //         this.account_org_phone = userData.account.org_phone;
        //         this.account_org_email = userData.account.org_email;
        //         this.account_website = userData.account.website;
        //         super.reset();
        //     }, 
        //     this.saveLoadError.bind(this));
    }

    load(processingWait = false) {
        super.load(processingWait);
        // if(processingWait) {
        //     this.api.getFileList(
        //         this.id, 
        //         this.authService.getUser().token,
        //         this.getFileListSuccess.bind(this),
        //         this.saveLoadError.bind(this));
        // }
        // this.api.getAdminList(
        //     this.account_owner_id,
        //     this.include_removed,
        //     this.search,
        //     this.whitelabel_id,
        //     this.page,
        //     this.limit,
        //     this.sortBy,
        //     this.sortDir,
        //     this.authService.getUser().token,
        //     this.saveLoadSuccess.bind(this),
        //     this.saveLoadError.bind(this));

    }
    saveLoadSuccess(data) {
        this.setData(data);
        if(this.refreshTimeout)
        {
            clearTimeout(this.refreshTimeout);
            this.refreshTimeout = null;
        }
        this.refreshTimeout = setTimeout(this.load.bind(this), 10000);

        this.dataList = data.list;
        //console.log('+++');
        //console.log(data.list);
        this.dataList = this.dataList.map(function(value, index, array){
            if(value.is_scheduled && value.is_sent != 1){
                //value.status_text = 'Changed...';
                //console.log('>>>>>>> value, index', value.is_scheduled, index);
                value.status_text =  'Scheduled [ ' + moment(value.gmt_time * 1000).format('MM/DD/YYYY hh:mm A') + ' ]';
            }
            return value;
            
        });
        
        this.count = data.count;
        this.pages =  Math.floor(this.count / this.limit);
        this.pages = this.pages * this.limit <= this.count ? this.pages + 1 : this.pages;

    }

    setData(data) {
        super.setData(data);
      
        this.accountApi.getUserData(
            this.account_owner_user_id,  
            this.authService.getUser().token, 
            (userData) => {
                this.account_org_phone = userData.account.org_phone;
                this.account_org_email = userData.account.org_email;
                this.account_website = userData.account.website;
                this.email = userData.user.email;
            }, 
            this.saveLoadError.bind(this));

        this.api.getFileList(
            this.id, 
            this.authService.getUser().token,
            this.getFileListSuccess.bind(this),
            this.saveLoadError.bind(this));

       
    }

    reproduce(setReady = false) {
        this.saving = true;
        var data = this.getData();
        data.set_ready = setReady;
        this.api.reproduce(
            data,
            this.authService.getUser().token,
            this.saveLoadSuccess.bind(this),
            this.saveLoadError.bind(this));
    }

    getFileListSuccess(files) {

        if(files.bucket) {

            this.fileBase = "https://" + files.bucket + ".s3.amazonaws.com/";
            this.files = files.files;
            this.awsCheck = true;

        }

        else {
            
            this.files = files;
            this.awsCheck = false;
            this.fileBase = "api/admin/videoEmail/downloadFile/" + this.id;
       
        }

    }
    onNavigate() {
        this.navPanelClass = '';
      }
    

    navigateLink(route, replace = false) {
        console.log("route param123",route);
        localStorage.setItem('rout', route);
        if(route.includes("#/user/video/email"))
        {
          if(route.includes("upload"))
          route = route + "?captureType=3" + "?videoUpload=1";
          else
          route = route + "?captureType=3";
          // window.location.href = "Posts?Category=" + sel;
        }
        if(route.includes("#/user/home") || route == "#/user" || route === "#/user/video/request" || route === "#/user/video/caseStudy" || route.includes("#/user/video/email"))
        {
          this.isdashboard = true;
          this.dashboardlength = 'col-sm-12';
          console.log("Dashboard value is",this.isdashboard);
          // window.location.href = "Posts?Category=" + sel;
        }
        else
        {
          this.isdashboard = false;
          this.dashboardlength = 'col-sm-9';
          console.log("Dashboard value is",this.isdashboard);
        }
        this.router.navigate(route, { replace: replace });
        this.onNavigate();
        document.body.scrollTop = document.documentElement.scrollTop = 0;
      }

      rowClicked(item) {
        if(item.status == 0 || item.status == 3 || item.status == 100)
        this.router.navigate("#/admin/video/email/" + item.id);
    }

   

    columnClicked(name) {
        if (this.sortBy == name) {
            if (this.sortDir == "ASC")
                this.sortDir = "DESC";
            else
                this.sortDir = "ASC";
            this.load();
        } else {
            this.sortBy = name;
            this.sortDir = "DESC";
            this.load();
        }
    }

    prev() {
        if (this.page > 1) {
            this.page--;
            this.dataList = null;
            this.load();
        }
    }

    next() {
        if (this.page < this.pages) {
            this.page++;
            this.dataList = null;
            this.load();
        }
    }

    limitChange() {
        console.log("event called",this.selectedlimitPages);
        if(this.limit != this.selectedlimitPages){
        this.limit = this.selectedlimitPages;
        this.dataList = null;
        this.load();
        }
      }

}
